import { Capacitor } from '@capacitor/core';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import DownloadAppPoster from '../components/DownloadAppPoster';

// Landing "/app": raggiunta SOLO da link esterni (QR code, social, campagne) — per scelta
// nessuna pagina dell'applicativo la linka. In app nativa non ha senso (e con gli Universal
// Links un click su https://ticinowild.ch/app apre l'app se installata): redirect alla home.
function AppLanding() {
    if (Capacitor.isNativePlatform()) return <Navigate to="/" replace />;

    return (
        <div className='min-h-[80svh] w-full px-4 py-10 flex items-center justify-center'>
            <Helmet>
                <title>Scarica l'app TicinoWild - iOS e Android</title>
                <meta name="description" content="Scarica l'app TicinoWild per iOS e Android: scopri, prenota e vivi le migliori attività outdoor e i prodotti tipici del Canton Ticino." />
                <link rel="canonical" href="https://ticinowild.ch/app" />
                <meta property="og:title" content="Scarica l'app TicinoWild - iOS e Android" />
                <meta property="og:description" content="Scopri, prenota e vivi le migliori attività outdoor e i prodotti tipici del Canton Ticino, direttamente dal tuo smartphone." />
                <meta property="og:url" content="https://ticinowild.ch/app" />
                <meta name="twitter:title" content="Scarica l'app TicinoWild - iOS e Android" />
                <meta name="twitter:description" content="Scopri, prenota e vivi le migliori attività outdoor e i prodotti tipici del Canton Ticino, direttamente dal tuo smartphone." />
            </Helmet>
            <DownloadAppPoster className='w-full max-w-[560px]' />
        </div>
    );
}

export default AppLanding;
